import dayjs from 'dayjs';

type TableHeadersYears<T extends Record<string, string>> = { [P in T[keyof T]]: string };

export const getTableHeadersYearsInitialValues = <T extends Record<string, string>>(
  columnNames: T,
  yearToStartFromPresent: number = 0,
): TableHeadersYears<T> => {
  const currentYear = dayjs().year();

  const result: TableHeadersYears<T> = Object.values(columnNames).reduce(
    (acc, yearName) => ({
      ...acc,
      [yearName]: `${currentYear + yearToStartFromPresent++}`,
    }),
    {} as TableHeadersYears<T>,
  );

  return result;
};
